import React, {useEffect, useRef} from "react";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {clearError, reset, selectError, selectIsSaving, setContactInfo} from "../../redux/user/contactInfoEntrySlice";
import {fetchUser, selectUser} from "../../redux/user/userSlice";
import {CountryCode, parsePhoneNumber} from "libphonenumber-js";
import {setCustomer} from "../../redux/checkout/checkoutSlice";
import {AlertDialog} from "../dialogs/AlertDialog";
import {Heading2, HeroHeading2} from "../text";
import {ContactInfoEntryContainerView} from "../contactInfoEntry/ContactInfoEntryContainerView";
import {Button} from "../buttons/Button";

export const AccountProfileSectionView: React.FC<any> = () => {
  const { t } = useTranslation()
  const error = useAppSelector(selectError)
  const isSaving = useAppSelector(selectIsSaving)

  const dispatch = useAppDispatch()

  const firstNameRef = useRef<HTMLInputElement>(null)
  const lastNameRef = useRef<HTMLInputElement>(null)
  const emailRef = useRef<HTMLInputElement>(null)
  const phoneNumberRef = useRef<HTMLInputElement>(null)
  const countryCodeRef = useRef<HTMLSelectElement>(null)

  useEffect(() => {
    dispatch(reset())
    dispatch(fetchUser())
  }, [dispatch])

  const handleSubmit = () => {
    const firstName = firstNameRef.current?.value
    const lastName = lastNameRef.current?.value
    let phoneNumber: string | undefined
    const email = emailRef.current?.value
    const countryCode: CountryCode | undefined = countryCodeRef.current?.value as CountryCode

    if (phoneNumberRef.current?.value && countryCode) {
      const parsedNumber = parsePhoneNumber(phoneNumberRef.current.value, countryCode)
      phoneNumber =  parsedNumber.number.toString()
    }

    dispatch(setContactInfo(
      {
        payload: {
          first_name: firstName,
          last_name: lastName,
          phone_number: phoneNumber,
          email
        },
        countryCode
      }
    ))
  }

  return <form
    className="w-full md:rounded-xl md:border-2 md:border-fg-gray-surface md:p-8 mx-auto"
    onSubmit={e => {
      e.preventDefault()
      handleSubmit()
    }}
  >
    <AlertDialog
      isOpen={!!error}
      error={error}
      buttons={[
        {
          title: { key: 'common:common_title_ok' },
          onClick: () => {
            dispatch(clearError())
          },
          style: 'default'
        }
      ]}
    />

    <div className={`mb-6 lg:mb-8`}>
      <Heading2>{t('auth:auth_title_contact_info')}</Heading2>
    </div>

    <div className="flex flex-col space-y-5">
      <ContactInfoEntryContainerView
        firstNameRef={firstNameRef}
        lastNameRef={lastNameRef}
        emailRef={emailRef}
        phoneNumberRef={phoneNumberRef}
        countryCodeRef={countryCodeRef} />

      <div className="hidden sm:flex">
        <Button
          size="lg"
          className="flex-shrink-0"
          isLoading={isSaving}
          onClick={() => {
            handleSubmit()
          }}
        >
          {t('common:common_title_update')}
        </Button>

        <div className="flex-grow" />
      </div>

      <div className="sm:hidden">
        <Button
          size="lg"
          isFullWidth
          isLoading={isSaving}
          onClick={() => {
            handleSubmit()
          }}
        >
          {t('common:common_title_update')}
        </Button>
      </div>
    </div>
  </form>
}